module.exports = __webpack_public_path__ + "static/media/back.1f3886b1.svg";